export const PIPELINE_SUBSTEPS_STORAGE_KEY = 'cockpit.pipelineTimeline.showSubsteps';
